import { styled } from '@mui/joy';

const Wrapper = styled('div')(({ theme }) => ({
  u: {
    textDecoration: 'none !important',
  },
  '.truncate-multiline': {
    display: '-webkit-box',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
  },
  '::-webkit-scrollbar': {
    width: '5px !important',
    height: '5px !important',
    borderRadius: '10px !important',
  },
  '::-webkit-scrollbar-track': {
    background: 'transparent !important',
  },
  '::-webkit-scrollbar-thumb': {
    background: `${theme.palette.neutral[300]} !important`,
    borderRadius: '10px !important',
  },
  '::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${theme.palette.neutral[600]} !important`,
  },
  '.MuiButton-root:disabled, .MuiButtonGroup-root .MuiButton-root:disabled': {
    cursor: 'not-allowed !important',
    pointerEvents: 'auto !important',
  },
}));

export const GlobalCustomCSSProvider = ({ children }: { children: React.ReactNode }) => {
  return <Wrapper>{children}</Wrapper>;
};
